import type { Phrases } from '../../common/Phrases.d';

import React from 'react';
import { Span } from '/react4xp/components/Element';
import { TextField } from '/react4xp/components/react-hook-form/TextField';
import {
	type Reaction,
	SERVICES_FIELD_NAME,
	FIELD_VALUE_REACTIONS,
} from '../constants';


export const ReactionsOtherTextField = ({
	phrases,
}: {
	phrases: Phrases;
}): React.JSX.Element => {
	const reactionsLabel = phrases['notificationForm.services.reactionsField.label'];
	const label = phrases['notificationForm.services.reactionsField.value.other'];
	return (
		<TextField
			errorSummaryLabel={`${reactionsLabel} - ${label}`}
			fullWidth
			label={<Span textSize='lg'>{label}</Span>}
			name={SERVICES_FIELD_NAME.REACTIONS_OTHER}
			showIf={
				({ watch }) => (watch({ name: SERVICES_FIELD_NAME.REACTIONS }) as Reaction[] || []).includes(FIELD_VALUE_REACTIONS.OTHER)
			}
		/>
	);
};
